import React from 'react';
import {
  Flex,
  Squish,
  Loader,
  ISquishProps,
} from '@grubhubprod/gh-cookbook-react';

export function SimpleLoader({
  borderRadius = '8px',
  inset = 'lg',
  borderColor,
  border,
  dimension,
}: ISquishProps): JSX.Element {
  return (
    <Squish
      inset={inset}
      border={border}
      borderColor={borderColor}
      borderRadius={borderRadius}
      dimension={dimension}
    >
      <Flex alignItems="center" justifyContent="center">
        <Loader />
      </Flex>
    </Squish>
  );
}
